<template>
  <div v-if="account && applicationId && token.length">
    <VueChat
      :appId="applicationId"
      :userId="account.id"
      :token="token"
      :accountType="accountType"
      :scColorSet="scColorSet"
      :hasBasicAccount="hasBasicAccount"
    />
  </div>
</template>

<script lang="ts">
import { ReactInVue } from 'vuera-ts';
import { readDomainCookie, writeDomainCookie } from '@/lib/domain_cookie';
import { readMeta } from '@/lib/page';
import { refreshedJwt } from '../../lib/jwt';
import { SENDBIRD_TOKEN_QUERY } from '@/graphql/messages/queries';
import { getOrRefreshToken } from './js/chatLogic';
import Chat from './Chat.jsx';

const VueChat = ReactInVue(Chat);

export default {
  name: 'MessagesApp',
  components: {
    VueChat,
  },
  data(): any {
    return {
      token: '',
    };
  },
  computed: {
    account() {
      return this.$store.getters['account/getAccount'];
    },
    applicationId(): string {
      return readMeta('sendbird_application_id') || '';
    },
    hasBasicAccount(): boolean {
      return this.account?.isBasic?.() && this.account?.isParent?.();
    },
    accountType(): string {
      if (this.account?.isSitter?.()) return 'sitter';
      if (this.account?.isParent?.()) return 'parent';
      return 'other';
    },
    scColorSet(): object {
      return {
        '--sendbird-light-primary-100': '#F3F3F3',
        '--sendbird-light-primary-200': '#282930',
        '--sendbird-light-primary-300': '#005988',
        '--sendbird-light-primary-400': '#034162',
        '--sendbird-light-primary-500': '#00487C',
        '--sendbird-light-onlight-01': '#282930',
        '--sendbird-light-onlight-02': '#6E6F74',
        '--sendbird-light-onlight-03': '#6E6F74',
      };
    },
  },
  mounted() {
    const setToken = (token) => {
      this.token = token;
    };
    getOrRefreshToken(readDomainCookie, this.account.id, this.getToken, setToken);
  },
  methods: {
    async getToken() {
      const token = await refreshedJwt();
      if (!token) throw new Error('Cannot access messages without being logged in');

      this.$apollo
        .query({
          query: SENDBIRD_TOKEN_QUERY,
        })
        .then((res) => {
          this.token = res.data.sendbirdSessionToken.token;
          writeDomainCookie(`user_${this.account.id}_sendbird_token`, res.data.sendbirdSessionToken);
        });
    },
  },
};
</script>
